import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { DefaultModel } from '@swf/core/models/widget';
import type { Dispatch } from '@swf/core/store';

import type { Announcement } from '../../types/index';
import AnnouncementList from '../AnnouncementList/AnnouncementList';
import ContactUs from '../ContactUs/ContactUs';
import Search from '../Search/Search';

import styles from './HelpContainer.scss';

interface Props {
  announcements: Announcement[];
  showTitle?: boolean;
  children?: React.ReactNode;
  id?: string;
}

const HelpContainer: React.FC<Props> = ({ children, announcements, id, showTitle = false }) => {
  const { widgetDispatch } = useWidget<void, DefaultModel>(id);
  const messengerFlag = useFeature(FeatureFlag.PSMessenger);
  const {
    help: { setMessenger }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    setMessenger({ messengerFlag });
  }, [messengerFlag, setMessenger]);

  useEffect(
    () => () => widgetDispatch && (widgetDispatch.clear() as never),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={styles.content}>
      <Search showTitle={showTitle} />
      <AnnouncementList announcements={announcements} />
      {children}
      <ContactUs />
    </div>
  );
};

export default HelpContainer;
